import { render, staticRenderFns } from "./pioneer6-explore.vue?vue&type=template&id=168466c3"
import script from "./pioneer6-explore.vue?vue&type=script&lang=js"
export * from "./pioneer6-explore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports